import {
  Navbar,
  NavbarItem,
  NavbarSection,
} from "@/components/catalyst/navbar";
import { Badge, BadgeColor } from "@/components/catalyst/badge";
import { useGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { blogPostStatusCountsQuery } from "@/app/Blogs/GraphQL/blogPostStatusCountsQuery";
import { BlogPostStatus } from "@/gql/graphql";

const tabs: {
  label: string;
  status: BlogPostStatus | null;
  countKey: "all" | "published" | "draft";
  badgeColor: BadgeColor;
}[] = [
  { label: "All", status: null, countKey: "all", badgeColor: "zinc" },
  {
    label: "Published",
    status: BlogPostStatus.Published,
    countKey: "published",
    badgeColor: "green",
  },
  {
    label: "Draft",
    status: BlogPostStatus.Draft,
    countKey: "draft",
    badgeColor: "zinc",
  },
];

export function BlogPostStatusTabs({
  status,
  onStatusChange,
}: {
  status: BlogPostStatus | null;
  onStatusChange: (status: BlogPostStatus | null) => void;
}) {
  const { data } = useGqlQuery(blogPostStatusCountsQuery, {});

  return (
    <div className="relative border-gray-200 pb-5 sm:border-b sm:pb-0">
      <h3 className="text-base font-semibold leading-6 text-gray-900">
        Blog posts
      </h3>
      <Navbar className="-mb-px">
        <NavbarSection>
          {tabs.map((tab) => {
            const count = data?.[tab.countKey].paginatorInfo.total;

            return (
              <NavbarItem
                key={tab.countKey}
                current={tab.status === status}
                onClick={() => onStatusChange(tab.status)}
              >
                {tab.label}
                {count ? (
                  <Badge className="py-0" color={tab.badgeColor}>
                    {count}
                  </Badge>
                ) : null}
              </NavbarItem>
            );
          })}
        </NavbarSection>
      </Navbar>
    </div>
  );
}
